var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFastdeliveredIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_61",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 11L8.66671 11.6667C8.66671 11.6667 13.6667 10.6667 14.3334 10.6667C15 10.6667 15 11.3334 14.3334 12C13.6667 12.6667 11.3334 14.6667 9.33337 14.6667C7.33337 14.6667 6.00004 13.6667 4.66671 13.6667H1.33337",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 9.66669C2.00004 9.00002 3.33337 8.00002 4.66671 8.00002C6.00004 8.00002 9.16671 9.33335 9.66671 10C10.1667 10.6667 8.66671 11.6667 8.66671 11.6667M5.33337 6.00002V3.33335C5.33337 3.15654 5.40361 2.98697 5.52864 2.86195C5.65366 2.73693 5.82323 2.66669 6.00004 2.66669H14C14.1769 2.66669 14.3464 2.73693 14.4714 2.86195C14.5965 2.98697 14.6667 3.15654 14.6667 3.33335V8.66669",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33337 2.66669H11.6667V5.66669H8.33337V2.66669Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "#28C76F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastdeliveredIcon);
export default __webpack_public_path__ + "static/media/fastdelivered_icon.51f04269bace871df0babbb3661fc9bc.svg";
export { ForwardRef as ReactComponent };